/**
 * @param field {HTMLElement}
 * @return {HTMLFormElement | undefined}
 */
module.exports = function getFormContainingField(field) {
    const form = field.closest("form");

    if (form instanceof HTMLFormElement) {
        return form;
    }
}